<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="relative z-10">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="
                w-full
                max-w-md
                transform
                overflow-hidden
                rounded-2xl
                bg-white
                p-6
                text-left
                align-middle
                shadow-xl
                transition-all
              "
            >
              <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                Warning
              </DialogTitle>
              <div class="mt-2">
                <p class="text-sm text-gray-500" v-html="warningText"></p>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogOverlay,
} from '@headlessui/vue';
import { getBrowserNameAndVersion, isMobileDevice } from '@/Utils/helpers';

export default {
  name: 'BrowserCheckModal',
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogOverlay,
  },
  mounted() {
    this.checkBrowser();
  },
  data() {
    return {
      platformSettings: this.$page.props.platformSettings,
      isOpen: false,
      browserNotAllowedWarningText:
        'Safari is not supported. Please use Google Chrome to get the best VCE experience. <a href="https://www.google.com/intl/en/chrome/" target="_blank" class="outline-none text-blue-600 dark:text-blue-500 hover:underline">Download here.</a>',
      warningText: '',
    };
  },
  methods: {
    checkBrowser() {
      if (!this.checkIfSafariBlocked()) {
        this.isOpen = false;
        return;
      }

      // Safari on a mobile device is allowed, since students commonly join
      // (e.g. via an email invitation or offline participation QR code) on a phone.
      if (isMobileDevice()) {
        this.isOpen = false;
        return;
      }

      this.warningText = this.browserNotAllowedWarningText;
      this.isOpen = true;
    },

    checkIfSafariBlocked() {
      const browserName = getBrowserNameAndVersion();

      if (browserName !== 'Apple Safari') {
        return false;
      }

      if (this.platformSettings.Browser !== undefined) {
        return !this.platformSettings.Browser.includes(browserName);
      }

      return true;
    },
  },
};
</script>
